const SET_ARCHIVED_CONTACTS_FILTERS = 'SET_ARCHIVED_CONTACTS_FILTERS';
export const setArchivedContactsFilters = (filters: ArchivedContactsFilters) => ({
  type: SET_ARCHIVED_CONTACTS_FILTERS,
  payload: filters,
});

export interface ArchivedContactsFilters {
  [key: string]: any;
}

const initialState: ArchivedContactsFilters = {};

interface Action {
  type: string;
  payload: ArchivedContactsFilters;
}

export const archivedContactsFiltersReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_ARCHIVED_CONTACTS_FILTERS:
      return { ...action.payload };

    default:
      return state;
  }
};
